import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2y1von4s08: FaireBrandEntity = {
  token: "b_2y1von4s08",
  type: "brand",
  name: "Namaste",
  avatarUrl:
    "https://cdn.faire.com/fastly/d5ef44e6cb9413101b8ead2a216d5c6bb76da1d9b4d1a10ad367e7771be14eee.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/31b948dae38b94f3e53e7444c6f5bb0d7f28d5bd32d298a5d3318f6de875410a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d5ef44e6cb9413101b8ead2a216d5c6bb76da1d9b4d1a10ad367e7771be14eee.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/31b948dae38b94f3e53e7444c6f5bb0d7f28d5bd32d298a5d3318f6de875410a.png",
  location: "GBR",
  minimumOrderDollars: 93,
  rating: 4.9,
  reviewCount: 529,
  isTopShop: true,
  isInsider: false,
  description:
    "In 1995, in search of some adventure, founder Sam Brummitt flew to Kathmandu, Nepal with a round-the-world ticket. After an inspirational trek to Mount Everest base camp, followed by 6 months circumnavigating the Indian Subcontinent on re-conditioned ex Indian Army Enfield Bullets and sleeping under the stars at the side of the road, the idea for the business slowly developed. Fuelled by a conversation one day in Rajasthan with the owner of a small textile business and now lifelong friend and a key supplier, Ganpat suggested Sam came back home and started a business.\n\nStarting a business meant earning a living while putting something back into such a beautiful and wonderful part of the world and that’s exactly what happened. Namaste, translated as ‘I greet the spirit within you’ was founded in 1997.\n\nOur Passions - We are dedicated to sourcing beautiful fairly traded products from the far corners of the world, embracing traditional artisan skills. We are passionate about ensuring our products where possible are made from environmentally friendly, sustainable and recycled materials.\n\nOur other passion is you, our customers. Many of our customers have been with us since the early days and we hope you have enjoyed the journey with us so far. We have a great team and look forward to developing the business and continuing the Namaste journey as we bring you our latest inspirational collections.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:36.225Z",
    importedBy: "entity-db-cli",
  },
};
